/**
 * i18n setup - react-i18next.
 * Faza 1 sesiune 31: infrastructura initiala. 6 limbi declarate (ro/en/fr/it/de/es).
 * Faza 2 in curs: extragere chei pe modul (common, scanx, configurator, media, pdf).
 *
 * Limba implicita: user.lang (din DB, cand exista) > localStorage > navigator > 'en' fallback.
 * Schimbare limba: PUT /api/auth/me/language + forced logout (cerinta user).
 *
 * NOTA: pentru fr/it/de/es, namespace-ul scanx a fost initializat ca placeholder din en.json.
 * Va fi tradus in Faza 3 via Emergent LLM key cu glosar tehnic injectat.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import roCommon from './locales/ro/common.json';
import enCommon from './locales/en/common.json';
import frCommon from './locales/fr/common.json';
import itCommon from './locales/it/common.json';
import deCommon from './locales/de/common.json';
import esCommon from './locales/es/common.json';

import roScanx from './locales/ro/scanx.json';
import enScanx from './locales/en/scanx.json';
import frScanx from './locales/fr/scanx.json';
import itScanx from './locales/it/scanx.json';
import deScanx from './locales/de/scanx.json';
import esScanx from './locales/es/scanx.json';

import roConfigurator from './locales/ro/configurator.json';
import enConfigurator from './locales/en/configurator.json';
import frConfigurator from './locales/fr/configurator.json';
import itConfigurator from './locales/it/configurator.json';
import deConfigurator from './locales/de/configurator.json';
import esConfigurator from './locales/es/configurator.json';

import roCatalog from './locales/ro/catalog.json';
import enCatalog from './locales/en/catalog.json';
import frCatalog from './locales/fr/catalog.json';
import itCatalog from './locales/it/catalog.json';
import deCatalog from './locales/de/catalog.json';
import esCatalog from './locales/es/catalog.json';

import roHelp from './locales/ro/help.json';
import enHelp from './locales/en/help.json';
import frHelp from './locales/fr/help.json';
import itHelp from './locales/it/help.json';
import deHelp from './locales/de/help.json';
import esHelp from './locales/es/help.json';

import roHelpObloane from './locales/ro/help_obloane.json';
import enHelpObloane from './locales/en/help_obloane.json';
import frHelpObloane from './locales/fr/help_obloane.json';
import itHelpObloane from './locales/it/help_obloane.json';
import deHelpObloane from './locales/de/help_obloane.json';
import esHelpObloane from './locales/es/help_obloane.json';

import roHelpIstoric from './locales/ro/help_istoric.json';
import enHelpIstoric from './locales/en/help_istoric.json';
import frHelpIstoric from './locales/fr/help_istoric.json';
import itHelpIstoric from './locales/it/help_istoric.json';
import deHelpIstoric from './locales/de/help_istoric.json';
import esHelpIstoric from './locales/es/help_istoric.json';

import roHelpComenzi from './locales/ro/help_comenzi.json';
import enHelpComenzi from './locales/en/help_comenzi.json';
import frHelpComenzi from './locales/fr/help_comenzi.json';
import itHelpComenzi from './locales/it/help_comenzi.json';
import deHelpComenzi from './locales/de/help_comenzi.json';
import esHelpComenzi from './locales/es/help_comenzi.json';

import roHelpServicii from './locales/ro/help_servicii.json';
import enHelpServicii from './locales/en/help_servicii.json';
import frHelpServicii from './locales/fr/help_servicii.json';
import itHelpServicii from './locales/it/help_servicii.json';
import deHelpServicii from './locales/de/help_servicii.json';
import esHelpServicii from './locales/es/help_servicii.json';

export const SUPPORTED_LANGS = [
  { code: 'ro', name: 'Romana' },
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Francais' },
  { code: 'it', name: 'Italiano' },
  { code: 'de', name: 'Deutsch' },
  { code: 'es', name: 'Espanol' },
];

const resources = {
  ro: { common: roCommon, scanx: roScanx, configurator: roConfigurator, catalog: roCatalog, help: roHelp, help_obloane: roHelpObloane, help_istoric: roHelpIstoric, help_comenzi: roHelpComenzi, help_servicii: roHelpServicii },
  en: { common: enCommon, scanx: enScanx, configurator: enConfigurator, catalog: enCatalog, help: enHelp, help_obloane: enHelpObloane, help_istoric: enHelpIstoric, help_comenzi: enHelpComenzi, help_servicii: enHelpServicii },
  fr: { common: frCommon, scanx: frScanx, configurator: frConfigurator, catalog: frCatalog, help: frHelp, help_obloane: frHelpObloane, help_istoric: frHelpIstoric, help_comenzi: frHelpComenzi, help_servicii: frHelpServicii },
  it: { common: itCommon, scanx: itScanx, configurator: itConfigurator, catalog: itCatalog, help: itHelp, help_obloane: itHelpObloane, help_istoric: itHelpIstoric, help_comenzi: itHelpComenzi, help_servicii: itHelpServicii },
  de: { common: deCommon, scanx: deScanx, configurator: deConfigurator, catalog: deCatalog, help: deHelp, help_obloane: deHelpObloane, help_istoric: deHelpIstoric, help_comenzi: deHelpComenzi, help_servicii: deHelpServicii },
  es: { common: esCommon, scanx: esScanx, configurator: esConfigurator, catalog: esCatalog, help: esHelp, help_obloane: esHelpObloane, help_istoric: esHelpIstoric, help_comenzi: esHelpComenzi, help_servicii: esHelpServicii },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS.map(l => l.code),
    defaultNS: 'common',
    ns: ['common', 'scanx', 'configurator', 'catalog', 'help'],
    // Sesiune 45: nonExplicitSupportedLngs trimite 'en-US' la 'en' (resources only have 2-char codes).
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: { escapeValue: false, skipOnVariables: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'oferte_lang',
      caches: ['localStorage'],
    },
    returnEmptyString: false,
  });

export default i18n;
